module.exports = __webpack_public_path__ + "img/medical-supplies.3eb0cc1f.png";